import { SettingsAction, SettingsState } from "./types";
import {API_AUTH_RESET} from "../../constants/API";

const initialState : SettingsState= {
    settingsIsShowed: false,
    paneIsResponsive: true,
    audioEnable: true,
    language: 'English',
    isLocalTime : true,
    playbackIsSynchronous: true,
    loadLastView: true,
    clearTextAfterSelection: true,
    localSettings: false,
    alarmPriority: '5',
    notificationPriority: '5',
    timeZone: 'Local'
};

const reducer = (state = initialState , action: SettingsAction) => {
    switch(action.type) {
        case ('triggerSettingsView'): return {
            ...state,
            settingsIsShowed: action.payload
        };

        case ('setLanguage'): return {
            ...state,
            language: action.language
        };

        case('setAlarmPriority'): return {
            ...state,
            alarmPriority: action.priority
        };

        case('setNotificationPriority'): return {
            ...state,
            notificationPriority: action.priority
        };

        case('setAudioEnable'): return {
            ...state,
            audioEnable: action.audioEnable
        };

        case('setClearTextAfterSelection'): return {
            ...state,
            clearTextAfterSelection: action.flag
        };

        case('setLoadLastView'): return {
            ...state,
            loadLastView: action.flag
        };
        case('setSynchronousPlayback'): return {
            ...state,
            playbackIsSynchronous: action.flag
        };

        case('setResponsivePane'): return {
            ...state,
            paneIsResponsive: action.flag
        };

        case('setFormatTime'): return {
            ...state,
            isLocalTime: action.flag
        };

        case('setTimeZone'): return {
            ...state,
            timeZone: action.zone
        };

        case('setLocalSettings'): return {
            ...state,
            localSettings: action.flag
        };

        case API_AUTH_RESET : return {
            ...initialState
        };

        case 'setStoredSettings' : return {
            ...state,
            language: action.language !== undefined ? action.language : state.language,
            localSettings: action.localSettings !== undefined ? action.localSettings : state.localSettings,
            isLocalTime: action.isLocalTime !== undefined ? action.isLocalTime : state.isLocalTime,
            timeZone: action.timeZone !== undefined ? action.timeZone : state.timeZone,
            paneIsResponsive: action.paneIsResponsive !== undefined ? action.paneIsResponsive : state.paneIsResponsive,
            loadLastView: action.loadLastView !== undefined ? action.loadLastView : state.loadLastView,
            clearTextAfterSelection: action.clearTextAfterSelection !== undefined ? action.clearTextAfterSelection : state.clearTextAfterSelection,
            alarmPriority: action.alarmPriority !== undefined ? action.alarmPriority : state.alarmPriority,
            notificationPriority: action.notificationPriority !== undefined ? action.notificationPriority : state.notificationPriority
        };

        default: return state
    }
};

export default reducer